import { render, staticRenderFns } from "./ProjectAddMemberModal.vue?vue&type=template&id=814f7fb8&scoped=true&"
import script from "./ProjectAddMemberModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddMemberModal.vue?vue&type=style&index=0&id=814f7fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f7fb8",
  null
  
)

export default component.exports